import { Component, OnInit, Inject, OnDestroy, Renderer2 } from '@angular/core';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { AuthenticationResult, InteractionStatus, PopupRequest, RedirectRequest, EventMessage, EventType } from '@azure/msal-browser';
import { lastValueFrom, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { NgxSpinnerService } from "ngx-spinner";
import { AppService } from './app.service';
import { SessionStorageService } from 'src/app/shared/services/session-storage.service';
import { Router } from '@angular/router';
import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';
import { GtmAnalyticsService } from './shared/services/gtm-analytics.service';
import { UiAnalyticsTrackerService } from 'src/app/shared/services/ui-analytics-tracker.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'IMS-UI';
  isIframe = false;
  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();
  partNosData: any;

  constructor(
    private permissionsService: NgxPermissionsService,
    private ngxRolesService:NgxRolesService,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private renderer: Renderer2,
    private spinner: NgxSpinnerService,
    private appService:AppService,
    private sessionStorageService: SessionStorageService,
    private router: Router,
    private gtmAnalytics: GtmAnalyticsService,
    private uiAnalyticsTracker: UiAnalyticsTrackerService
  ) {
  }



  ngOnInit(): void {
      const analyticsAppName = environment.analyticsAppName || 'apmt-am-ims';
      localStorage.setItem('analytics_appName', analyticsAppName);

    // this.router.navigate([''])
    this.isIframe = window !== window.parent && !window.opener; // Remove this line to use Angular Universal
    this.setLoginDisplay();
    this.authService.instance.enableAccountStorageEvents(); // Optional - This will enable ACCOUNT_ADDED and ACCOUNT_REMOVED events emitted when a user logs in or out of another tab or window
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) =>
            msg.eventType === EventType.ACCOUNT_ADDED ||
            msg.eventType === EventType.ACCOUNT_REMOVED
        )
      )
      .subscribe((result: EventMessage) => {
        if (this.authService.instance.getAllAccounts().length === 0) {
          window.location.pathname = '/';
        } else {
          this.setLoginDisplay();
        }
      });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None
        ),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
        this.checkAndSetActiveAccount();
        this.getAllPartNos();
        this.getFiltersData();
      });
    this.uiAnalyticsTracker.startTracking();

    if (environment.gtmContainerId) {
      localStorage.setItem('analytics_appName', environment.analyticsAppName);
      this.gtmAnalytics.loadAnalytics();
    }
  }



 simplyfyPermission(permissionType:string,permissionVal:any,permissionArr:any){
  switch(permissionVal) {
    case "W":
      permissionArr.push(`canWrite${permissionType}`);
      permissionArr.push(`canRead${permissionType}`);
      break;
    case "R":
      permissionArr.push(`canRead${permissionType}`);
      break;
    case "NA":
        // code block
        break;
    default:
      // code block
  }

  return permissionArr;
 }
 processRolePermission(permissionObj:any){

    let permissionArr:any=[];
    let userRole:any=permissionObj.userRole;
    permissionArr=this.simplyfyPermission('Admin',permissionObj.admin,permissionArr);
    permissionArr=this.simplyfyPermission('GlobalOverview',permissionObj.globalOverview,permissionArr);
    permissionArr=this.simplyfyPermission('InventoryPlanning',permissionObj.inventoryPlanning,permissionArr);
    permissionArr=this.simplyfyPermission('PartsCategorization',permissionObj.partsCategorization,permissionArr);
    permissionArr=this.simplyfyPermission('PartsPlanning',permissionObj.partsPlanning,permissionArr);
    permissionArr=this.simplyfyPermission('PlanningOverview',permissionObj.planningOverview,permissionArr);
    permissionArr=this.simplyfyPermission('ValueCategorization',permissionObj.valueCategorization,permissionArr);
    this.ngxRolesService.addRoleWithPermissions(userRole, permissionArr)
    //this.permissionsService.loadPermissions([userRole]);
    var permissions = this.permissionsService.getPermissions();
    let role = this.ngxRolesService.getRole(userRole);

 }

 setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  }

  checkAndSetActiveAccount(){
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    let msalUserInfo = this.authService.instance.getActiveAccount()?.idTokenClaims;
    // this.msalUserInfo = this.authUserService.getUserData();
    if (msalUserInfo) {
      let userId = msalUserInfo && msalUserInfo['employeeID'];
      let userName: any = msalUserInfo && msalUserInfo['name'];
      let userEmail: any = msalUserInfo && msalUserInfo['preferred_username'];
      const telemetryUserId = String(userId || '');
      const telemetryUserName = String(userName || '');
      const telemetryUserEmail = String(userEmail || '');
      sessionStorage.setItem('userId', telemetryUserId);
      localStorage.setItem('userId', JSON.stringify(telemetryUserId));
      this.sessionStorageService.userName = userName;
      this.sessionStorageService.userEmail = userEmail;
      sessionStorage.setItem('userName', userName);
      sessionStorage.setItem('userEmail', userEmail);
      localStorage.setItem('userName', JSON.stringify(telemetryUserName));
      localStorage.setItem('userEmail', JSON.stringify(telemetryUserEmail));

      const setImsTelemetryUser = (window as any).setImsTelemetryUser;
      if (typeof setImsTelemetryUser === 'function') {
        setImsTelemetryUser(telemetryUserName);
      }
    }

    let activeAccount = this.authService.instance.getActiveAccount();

    if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
      let accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);
      this.getAllPartNos();
    }
  }

  getAllPartNos(){
    let req= "ALL";
    this.spinner.show();
    this.appService.getPartNos(req)
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          if (res && res.data) {
            this.partNosData = res.data;
            this.sessionStorageService.PartNosMasterData = res.data;
          } else {
          }
        },
        error: (err) => {

        }
      })
  }

  getFiltersData() {
    this.appService.getIPFilterOptions()
      .subscribe({
        next: (res) => {
          if (res && res.data) {
            this.sessionStorageService.InventoryPlanningFilteredData = res.data;

          }
        },
        error: (err) => {

        }
      })
  }

  loginRedirect() {
    if (this.msalGuardConfig.authRequest){
      this.authService.loginRedirect({...this.msalGuardConfig.authRequest} as RedirectRequest);
    } else {
      this.authService.loginRedirect();
    }
  }

  logout(popup?: boolean) {
    if (popup) {
      this.authService.logoutPopup({
        mainWindowRedirectUri: "/"
      });
    } else {
      this.authService.logoutRedirect();
    }
  }

  ngOnDestroy(): void {
    this.uiAnalyticsTracker.stopTracking();
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  ngAfterViewInit() {
    let loader = this.renderer.selectRootElement('#loader');
    this.renderer.setStyle(loader, 'display', 'none');
  }
}
